import { validator } from "@/utils/validator";

export const masterDataLivingRelationshipSchema = validator.object().shape({
  relationship: validator.string().emptyToNull().label("続柄").required(),
  xLivingRelationshipRenewVisaCsvCode: validator.string().emptyToNull().label("期間更新CSVのコード（列X）").required(),
});
